import React from 'react';
import { ChevronRight, Home } from 'lucide-react';
import { Link } from 'react-router-dom';
import { EquipmentBreadcrumb as BreadcrumbItem } from '../../api/services/equipment.api';
import { cn } from '../../lib/utils';

interface EquipmentBreadcrumbProps {
  breadcrumbs: BreadcrumbItem[];
  className?: string;
}

export const EquipmentBreadcrumb: React.FC<EquipmentBreadcrumbProps> = ({
  breadcrumbs,
  className,
}) => {
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }

  return (
    <nav
      className={cn('flex items-center gap-1 text-sm text-muted-foreground', className)}
      aria-label="Breadcrumb"
    >
      {/* Home Icon */}
      <Link
        to="/equipment"
        className="hover:text-foreground transition-colors"
        aria-label="All Equipment"
      >
        <Home className="h-4 w-4" />
      </Link>

      {/* Breadcrumb Items */}
      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <React.Fragment key={item.id}>
            <ChevronRight className="h-4 w-4" aria-hidden="true" />
            {isLast ? (
              <span className="text-foreground truncate">{item.name}</span>
            ) : (
              <Link
                to={`/equipment/${item.id}`}
                className="hover:text-foreground transition-colors truncate"
              >
                {item.name}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};
